import { render, staticRenderFns } from "./Stripes.vue?vue&type=template&id=5d0ac9b8&scoped=true&"
var script = {}
import style0 from "./Stripes.vue?vue&type=style&index=0&id=5d0ac9b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0ac9b8",
  null
  
)

component.options.__file = "Stripes.vue"
export default component.exports